import axios from 'axios';

const formatPayloadForLog = data => {
	if (typeof FormData !== 'undefined' && data instanceof FormData) {
		return '[FormData]';
	}
	if (typeof Blob !== 'undefined' && data instanceof Blob) {
		return '[Blob]';
	}
	return data;
};

if (!axios.__A_EYES_LOGGER_ATTACHED__) {
	const logRequest = config => {
		const method = (config.method || 'get').toUpperCase();
		const base = config.baseURL ?? '';
		const url = config.url ?? '';
		console.info('[API REQUEST]', method, `${base}${url}`, {
			params: config.params,
			data: formatPayloadForLog(config.data),
		});
		return config;
	};

	const logResponse = response => {
		const { config } = response;
		const method = (config.method || 'get').toUpperCase();
		const base = config.baseURL ?? '';
		const url = config.url ?? '';
		console.info('[API RESPONSE]', response.status, method, `${base}${url}`);
		return response;
	};

	const logError = error => {
		if (error.config) {
			const method = (error.config.method || 'get').toUpperCase();
			const base = error.config.baseURL ?? '';
			const url = error.config.url ?? '';
			const status = error.response?.status ?? 'NETWORK_ERROR';
			console.error('[API ERROR]', status, method, `${base}${url}`, {
				data: formatPayloadForLog(error.response?.data) ?? error.message,
			});
		} else {
			console.error('[API ERROR]', error);
		}
		return Promise.reject(error);
	};

	axios.interceptors.request.use(logRequest, error => Promise.reject(error));
	axios.interceptors.response.use(logResponse, logError);
	axios.__A_EYES_LOGGER_ATTACHED__ = true;
}

export const API_BASE_URL = 'https://app.a-eyes.app/api/';

const token = () => {
	return localStorage.getItem('token');
};

const authHeaders = () => {
	return token()
		? {
				Authorization: `Token ${token()}`,
		  }
		: {};
};

export const doGet = (url, params) => {
	return axios.get(API_BASE_URL + url, {
		params: params,
		timeout: 200000,
		headers: {
			...authHeaders(),
		},
	});
};

export const doPost = (url, body, params) => {
	return axios.post(API_BASE_URL + url, body, {
		params: params,
		timeout: 200000,
		headers: {
			...authHeaders(),
		},
	});
};

export const doDelete = (url, params) => {
	return axios.delete(API_BASE_URL + url, {
		params,
		timeout: 200000,
		headers: {
			...authHeaders(),
		},
	});
};

export const doPostWithoutHeader = (url, body, params) => {
	return axios.post(API_BASE_URL + url, body, {
		params: params,
		timeout: 200000,
	});
};

export const doLogin = (url, body) => {
	return axios.post(API_BASE_URL + url, body, {
		timeout: 200000,
	});
};
